import JwtService from './jwtService';

export default function useJwt(): JwtService {
  return new JwtService();
}
